<ul class="nav nav-tabs" [dir]="rtl ? 'rtl' : 'ltr'">
    <li class="nav-item" *ngFor="let tab of tabItems; let $index = index">
        <div class="nav-link" [id]="tab.id" [ngClass]="tab.active ? 'active' : ''" (click)="activateTab(tab)">
            {{ tab.title }}
        </div>
    </li>
</ul>
<div>
    <ng-content></ng-content>
</div>